import useFilePreview from "@/hooks/useFilePreview"
import React, { useState } from "react"
import Tesseract from "tesseract.js"

const TestOrcPage = () => {
  const [image, setImage] = useState<File | null>(null)
  const [text, setText] = useState("")
  const [nik, setNik] = useState("")
  const [loading, setLoading] = useState(false)

  const filePreview = useFilePreview(image)

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      setImage(file)
    }
  }

  const handleOCR = () => {
    if (!image) return

    setLoading(true)
    Tesseract.recognize(image, "eng", {
      logger: (m) => console.log(m),
    }).then(({ data: { text } }) => {
      setText(text)
      // Cari NIK dengan regex (16 digit angka di awal)
      const matchNik = text.match(/\b\d{16}\b/)
      setNik(matchNik ? matchNik[0] : "NIK tidak ditemukan")
      setLoading(false)
    })
  }

  return (
    <div>
      <h2>OCR KTP (Client-side)</h2>
      <input type="file" accept="image/*" onChange={handleImageChange} />
      <button onClick={handleOCR} disabled={loading}>
        {loading ? "Memproses..." : "Proses OCR"}
      </button>
      {nik && (
        <p>
          <strong>NIK:</strong> {nik}
        </p>
      )}
      {/* Optional: tampilkan teks lengkap */}
      <pre>{text}</pre>
      {filePreview && <img src={filePreview} />}
    </div>
  )
}

export default TestOrcPage
